import React from 'react';
import { useNavigate } from 'react-router-dom';

import notFound from '../../assets/images/notFound.gif'
import MyButton from '../../shared-components/button/Button';

/**
 * NotFound component renders a message indicating that the requested page was not found.
 *
 * This component is typically displayed when a user navigates to a URL
 * that does not match any existing route in the application.
 * @returns {JSX.Element} The rendered component showing a "Not Found" message.
 */
function NotFound() {
  const navigate = useNavigate();
  /**
   * Handles the submission of a form or an action.
   *
   * This function is triggered when the user submits the form,
   * and it processes the input values as necessary.
   */
  const submit = () => {
    navigate('/login/credentials');
  };

    return (
        <div className="notfound-error-main-page">
            <div className="image-container">
                <img src={notFound} alt='' />
            </div>
            <div className="content-container">
                <h3>Error</h3>
                <p>The page was not found</p>
                <div className="content-btn">
                    <MyButton label="Take me to home" buttonType="submit" onClickFunc={submit} disableHoverEffect/>
                </div>
            </div>
        </div>
  );
}

export default NotFound;
